<template>
    <v-card class="elevation-0 pa-5" color="gray">

        <v-layout wrap row justify-space-between>
            <h1 class="fonte text-uppercase">Gerenciar Empresas</h1>
            <v-btn color="teal" class="white--text" round @click="dialog=true">Nova Empresa</v-btn>
        </v-layout>
        <v-divider class="mt-3 mb-4"></v-divider>

        <v-dialog v-if="dialog" v-model="dialog" width="800">
            <v-card class="pa-3">
                <v-container grid-list-md text-xs-center>
                    <v-layout wrap row justify-space-between>
                        <v-flex xs4>
                            <v-text-field box color="teal" label="Nome da empresa" v-model="empresa.nome"></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field box color="teal" label="Domínio da empresa" v-model="empresa.dominio"></v-text-field>
                        </v-flex>

                        <v-flex xs4>
                            <v-text-field box color="teal" label="URL da Original" v-model="empresa.service_uri"></v-text-field>
                        </v-flex>

                        <v-flex xs4>
                            <v-text-field box color="teal" label="URL da Logo" v-model="empresa.logo"></v-text-field>
                        </v-flex>

                        <v-flex xs4>
                            <v-autocomplete
                                box
                                :items="usuariosInternos"
                                v-model="empresa.astandes_token"
                                no-data-text="Nenhuma empresa encontrada"
                                item-text="firstname"
                                item-value="key"
                                label="Selecine empresa Astandes"
                                color="teal"
                            ></v-autocomplete>
                        </v-flex>

                        <v-flex xs4>
                            <v-text-field box color="teal" maxlength="6" placeholder="Sem #" label="Cor em Hexadecimal" v-model="empresa.cor"></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field box color="teal" label="Desconto em porcentagem" v-model="empresa.desconto"></v-text-field>
                        </v-flex>
                        <v-flex xs>
                            <v-textarea
                                box
                                label="Descrição da empresa"
                                auto-grow
                                v-model="empresa.description"
                                :rows="1"
                            ></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-expansion-panel>
                    <v-expansion-panel-content class="pa-2" >
                        <template v-slot:header>
                            <div>Configurações opcionais</div>
                        </template>

                        <v-layout wrap row justify-space-between>
                            <v-flex xs5>
                                <v-text-field box
                                    placeholder="(##)#####-####"
                                    v-mask="'(##)#####-####'"
                                    color="teal"
                                    label="Numero whatsapp da empresa"
                                    v-model="empresa.whatsapp"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field box color="teal" label="URL do WebAPP na Original" v-model="empresa.webapporiginal_url"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    box
                                    label="Mensagem enviada no SMS de código de verificacao"
                                    auto-grow
                                    v-model="empresa.messageSMSCodeVerification"
                                    :rows="1"
                                ></v-textarea>
                            </v-flex>

                            <v-flex xs12>
                                <v-textarea
                                    box
                                    label="Mensagem enviada no SMS de ticket link"
                                    auto-grow
                                    v-model="empresa.messageSMSTicketLink"
                                    :rows="1"
                                ></v-textarea>
                            </v-flex>
                        </v-layout>

                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-flex mt-2>
                    <v-btn round @click="resetForm" class="white--text" color="error">Cancelar</v-btn>
                    <v-btn :loading="loading" v-if="!updateCompany" @click="create" round class="white--text" color="fundo">Criar</v-btn>
                    <v-btn :loading="loading" v-else @click="update" round class="white--text" color="fundo">Atualizar</v-btn>
                </v-flex>
            </v-card>
        </v-dialog>

        <v-data-table
            :items="empresas"
            :headers="headers"
            hide-actions
            :loading="loading"
        >
            <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.nome || 'sem nome para não quebrar o layout' }}</td>
                <td class="text-xs-center">{{ props.item.dominio }}</td>
                <td class="text-xs-center">
                    <input :ref="props.item._id" :value="props.item.token" />
                    <v-btn @click="copiar(props.item._id)" small icon>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg>
                    </v-btn>
                </td>
                <td class="text-xs-center">{{ props.item.service_uri }}</td>
                <td class="text-xs-center">
                    <v-switch
                        v-model="props.item.enabled"
                        @change="changeStatus(props.item._id, $event)"
                    ></v-switch>
                </td>
                <td class="text-xs-center">
                    <v-btn small icon @click="updateItem(props.item)"><v-icon class="v-icon icon-home material-icons">edit</v-icon></v-btn>
                    <v-btn small icon @click="remove(props.item._id)"><v-icon class="v-icon icon-home material-icons">delete</v-icon></v-btn>
                </td>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex'

import CTable from '../../CTable'

export default {
    components: {
        CTable
    },

    data() {
        return {
            dialog: false,
            loading: false,
            empresa: {
                nome: '',
                dominio: '',
                service_uri: '',
                astandes_token: '',
                logo: '',
                cor: '',
                desconto: '',
                description: '',
                whatsapp: '',
                webapporiginal_url: '',
                messageSMSCodeVerification: '',
                messageSMSTicketLink: ''
            },
            usuariosInternos: [],
            empresas: [],
            headers: [
                {
                    text: "Empresa",
                    align: "center",
                    value: "nome",
                    sortable: true
                },
                {
                    text: "Domínio",
                    align: "center",
                    value: "dominio",
                    sortable: false
                },
                {
                    text: "Token da Empresa",
                    align: "center",
                    value: "token",
                    sortable: false
                },
                {
                    text: "URL na Original",
                    align: "center",
                    value: "service_uri",
                    sortable: false
                },
                {
                    text: "Ativada",
                    align: "center",
                    value: "enabled",
                    sortable: false
                },
                {
                    text: "Ações",
                    align: "center",
                    value: "acoes",
                    sortable: false
                }
            ],
            updateCompany: false
        }
    },

    mounted() {
        this.loadUsuarios()
        this.loadCompanies()
    },

    methods: {
        ...mapActions([
            'loadUsuariosAstandes', 'loadAllCampaniesQueroTaxi', 'createOrEditQueroTaxi',
            'removeCompanyQueroTaxi', 'cahngeStatusQueroTaxi'
        ]),

        copiar(ref) {
            let x = this.$refs[ref]
            x.select()
            document.execCommand('copy')
        },

        async loadUsuarios() {
            this.usuariosInternos = await this.loadUsuariosAstandes()
        },

        async loadCompanies() {
            const { status, empresas } = await this.loadAllCampaniesQueroTaxi()
            status && ( this.empresas = empresas )
        },

        resetForm() {
            this.dialog         = false
            this.updateCompany  = false
            this.empresa        = {
                nome: '',
                dominio: '',
                service_uri: '',
                astandes_token: '',
                logo: '',
                cor: '',
                desconto: '',
                description: '',
                whatsapp: '',
                webapporiginal_url: '',
                messageSMSCodeVerification: '',
                messageSMSTicketLink: ''
            }
        },

        updateItem(item) {
            item.cor = item.cor.replace('#', '')
            this.empresa        = item
            this.updateCompany  = true
            this.dialog         = true
        },

        validate() {

        },

        async create() {
            this.loading = true
            const { status, empresa, message } = await this.createOrEditQueroTaxi(this.empresa)
            if(status) {
                this.$eventHub.$emit('snackBar', {color: 'success', message: 'Empresa criada com sucesso'})
                await this.loadCompanies()
                this.resetForm()
            } else {
                this.$eventHub.$emit('snackBar', {color: 'error', message: message || 'Erro ao criar empresa'})
            }
            this.loading = false
        },

        async update() {
            this.loading = true
            const { status, empresa, message } = await this.createOrEditQueroTaxi(this.empresa)

            if(status) {
                this.$eventHub.$emit('snackBar', {color: 'success', message: 'Empresa atualizada com sucesso'})
                await this.loadCompanies()
                this.resetForm()
            } else {
                this.$eventHub.$emit('snackBar', {color: 'error', message: message || 'Erro ao atualizar empresa'})
            }
            this.loading = false
        },

        async remove(id) {
            this.loading = true
            const { status, message } = await this.removeCompanyQueroTaxi(id)

            if(status) {
                this.$eventHub.$emit('snackBar', {color: 'success', message: 'Empresa removida com sucesso'})
                await this.loadCompanies()
                this.resetForm()
            } else {
                this.$eventHub.$emit('snackBar', {color: 'error', message: message || 'Erro ao remover empresa'})
            }
            this.loading = false
        },

        async changeStatus(id, enabledStatus) {
            this.loading = true
            const { status, message } = await this.cahngeStatusQueroTaxi({id, status: enabledStatus})

            if(status) {
                this.$eventHub.$emit('snackBar', {color: 'success', message: message || 'Status alterado com sucesso'})
                await this.loadCompanies()
                this.resetForm()
            } else {
                this.$eventHub.$emit('snackBar', {color: 'error', message: message || 'Erro ao atualizar status'})
            }
            this.loading = false
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/root/QueroTaxi/Empresas.vue